<template>
  <div class="order">
    <div class="title">
      訂單管理
    </div>
    <div class="filter">
      <el-row>
        <el-col :span="24">
          <el-cascader
            v-if="isDepartment || userInfo.roleID == 3"
            v-model="sourceType"
            placeholder="訂單類型"
            class="w150"
            :show-all-levels="false"
            :options="sourceTypeList"
            popper-class="cascader"
            :props="{
              checkStrictly: true,
              children: 'children',
              value: 'dictionaryValue',
              label: 'dictionaryNameWithCulture',
              emitPath: false
            }"
          />
          <el-select
            v-model="orderStatus"
            class="w120"
            placeholder="訂單狀態"
          >
            <el-option
              label="全部"
              :value="0"
            />
            <el-option
              v-for="item in orderStatusList"
              :key="item.dictionaryValue"
              :label="item.dictionaryNameWithCulture"
              :value="item.dictionaryValue"
            />
          </el-select>
          <el-select
            v-model="paymentTypeList"
            class="w165"
            multiple
            collapse-tags
            placeholder="付款方式"
          >
            <el-option
              label="全部"
              :value="0"
            />
            <el-option
              v-for="item in orderPaymentType"
              :key="item.dictionaryValue"
              :label="item.dictionaryNameWithCulture"
              :value="item.dictionaryValue"
            />
          </el-select>
          <!-- 组织 -->
          <el-cascader
            v-if="isDepartment"
            v-model="departmentID"
            filterable
            placeholder="組別"
            class="w150"
            :show-all-levels="false"
            :options="departmentList"
            :props="{
              checkStrictly: true,
              children: 'childNode',
              value: 'departmentID',
              label: 'departmentName',
              emitPath: false
            }"
          />
          <el-input
            v-if="!isDisabledPublish"
            v-model="couponNo"
            class="w165"
            placeholder="請輸入優惠碼編號"
            suffix-icon="el-icon-search"
          />
        </el-col>
        <!--樓盤編號  -->
        <el-col>
          <el-input
            v-model="orderId"
            class="w150"
            placeholder="訂單編號"
            suffix-icon="el-icon-search"
            @input="checkInt('orderId')"
          />
          <el-input
            v-model="sourceID"
            class="w150"
            placeholder="樓盤編號"
            suffix-icon="el-icon-search"
            @input="checkInt('sourceID')"
          />日期： 
          <el-date-picker
            v-model="startTime"
            format="yyyy/MM/dd"
            value-format="timestamp"
            class="w150 mr4"
            type="date"
            :picker-options="startTimeOption"
            placeholder="選擇日期"
          />—
          <el-date-picker
            v-model="endTime"
            format="yyyy/MM/dd"
            value-format="timestamp"
            class="w150"
            :picker-options="endTimeOption"
            type="date"
            placeholder="選擇日期"
          />
          <el-button
            type="danger"
            @click="clickSearch"
          >
            搜尋
          </el-button>
          <el-button
            type="info"
            @click="resetSearch"
          >
            重置
          </el-button>
          <button
            class="hoverButton"
            @click="depExc"
          >
            導出
          </button>
        </el-col>
      </el-row>
    </div>
    <div class="line" />
    <div class="button">
      <span
        class="span"
        @click="clickPay"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use :xlink:href="isPay ? '#iconfukuan-copy' : '#iconfukuan'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: !isPay }">立即付款</span>
      </span>
      <span
        class="span"
        @click="cancelOrder"
      >
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use :xlink:href="isDel ? '#iconquxiaodingdan-copy' : '#iconquxiaodingdan'" />
        </svg>
        <span :class="{ 'btn-text': true, ban: !isDel }">取消訂單</span>
      </span>
    </div>
    <div class="table">
      <!-- 文字列表 -->
      <div class="text-list">
        <!-- 宽度调整 -->
        <el-table
          v-loading="firstLoading"
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
          :data="orderList"
          empty-text="暫無數據"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <!--编号- >>- 订单编号 -->
          <el-table-column
            prop="orderID"
            label="訂單編號"
            min-width="100"
          />
          <el-table-column
            label="賬戶類型"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.accountType">公司賬戶</span>
              <span v-else>個人賬戶</span>
            </template>
          </el-table-column>
          <!-- 宽度调整 -->
          <el-table-column
            label="組別"
            width="200"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.departmentName">{{ scope.row.departmentName }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="訂單類型"
            min-width="130"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.sourceType === 'Property'">
                {{ scope.row.itemWithCulture }}<br>{{ scope.row.couponBatchName ? scope.row.couponBatchName : '' }}
              </span>
              <span v-else-if="scope.row.sourceType === 'PropertyCoin'">購買金幣</span>
              <span v-else-if="scope.row.sourceType === 'Diamond'">購買鑽石</span>
              <span v-else-if="scope.row.sourceType === 'Coupon'">優惠碼兌換-<br>{{ scope.row.couponNo }}</span>
              <span v-else>{{ scope.row.itemWithCulture }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="樓盤編號"
            min-width="100"
          >
            <!-- 进入详情页 -->
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.propertyID !== '--' || !scope.row.propertyID"
                class="btn-a"
                type="text"
                @click="enterDetails(scope.row.rentalType, scope.row.propertyID)"
              >
                {{ scope.row.propertyID }}
              </el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="訂單狀態"
            min-width="120"
          >
            <template slot-scope="scope">
              <p class="order-statu">
                {{ scope.row.orderStatusWithCulture }}
              </p>
              <p class="order-statu-red">
                {{ scope.row.expireTimeCulture ? `(${scope.row.expireTimeCulture}後過期)` : null }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            label="時間"
            min-width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | getTime }}
              {{ scope.row.createTime | getDateTime }}
            </template>
          </el-table-column>
          <!-- 金币记录 -->
          <el-table-column
            v-if="isShowCoinHistory"
            label="金幣數量"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.propertyCoin">{{ scope.row.propertyCoin }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 钻石记录 -->
          <el-table-column
            v-if="isShowDiamondHistory"
            label="鑽石數量"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.diamond">{{ scope.row.diamond }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="金額" min-width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.money && scope.row.sourceType != 'AutoRecommend'">HK${{ scope.row.money }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column> -->
          <el-table-column
            prop="accountName"
            label="操作人"
            min-width="150"
            :show-overflow-tooltip="true"
          />
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          class="page"
          background
          :page-size="pageCount"
          :page-sizes="[10, 20, 50, 100]"
          layout="total,sizes,prev, pager, next,jumper"
          :current-page="pageIndex"
          :total="count"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
    </div>
    <!-- 暂停放盘方式 -->
    <el-dialog
      top="25vh"
      class="ti-shi"
      title="提示"
      width="480px"
      :visible.sync="isShowDiamondPrompt"
    >
      <div class="tishi">
        <i class="el-icon-info icon" />
        <div>
          無法付款，你的公司已暫停使用此放盤方式，
          <br>如需繼續使用，請與我們銷售部聯絡 (Tel: 3619 3218)
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="isShowDiamondPrompt = false">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="isShowDiamondPrompt = false"
        >
          確 認
        </el-button>
      </div>
    </el-dialog>
    <!-- 暂停使用钻石金币 -->
    <el-dialog
      top="25vh"
      class="ti-shi"
      title="提示"
      width="480px"
      :visible.sync="isUsedDiamondPrompt"
    >
      <div class="tishi">
        <i class="el-icon-info icon" />
        <div v-if="diamondOrCoin == 'Diamond'">
          無法付款，你的公司已暫停使用House730鑽石，
          <br>如需繼續使用，請與我們銷售部聯絡 (Tel: 3619 3218)
        </div>
        <div v-else-if="diamondOrCoin == 'Coin'">
          無法付款，你的公司已暫停使用House730金幣，
          <br>如需繼續使用，請與我們銷售部聯絡 (Tel: 3619 3218)
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="isUsedDiamondPrompt = false">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="isUsedDiamondPrompt = false"
        >
          確 認
        </el-button>
      </div>
    </el-dialog>
    <!-- 导出excel 弹出 -->
    <el-dialog
      class="ti-me"
      title="選擇導出日期"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="dateAll">
        <span>時間範圍：&nbsp;&nbsp;</span>
        <span class="dateSel">
          <el-radio-group
            v-model="checkedCities"
            :max="1"
          >
            <el-radio
              v-for="item in checkDate"
              :key="item"
              :label="item"
              @change="dateChange"
            >{{ item }}</el-radio>
          </el-radio-group>
        </span>
      </div>
      <div>
        <span>選擇日期：&nbsp;&nbsp;</span>
        <span class="block">
          <span>
            <el-date-picker
              v-model="value1"
              :disabled="checkedCities == '自訂日期' ? false : true"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              style="width: 250px"
              value-format="timestamp"
            />
            <p
              v-if="warnShow"
              class="selDat"
            >請選擇日期</p>
          </span>
        </span>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="checkedCities == '' || checkedCities == undefined || checkedCities == null"
          @click="downloadExl"
        >確 認</el-button>
      </span>
    </el-dialog>
    <el-dialog
      top="25vh"
      class="ti-shi"
      title="提示"
      width="400px"
      :visible.sync="isShowPayPrompt"
    >
      <div class="del-tishi">
        <div>
          <span class="span">因樓盤資料不完整，無法付款，須先補回填寫資料</span>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="isShowPayPrompt = false"
        >
          確 認
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
    name: 'Agent',
    data() {
        return {
            isShowPayPrompt:false,
            value1: [],
            warnShow: false,
            checkDate: ['全部', '自訂日期'],
            checkedCities: '全部',
            dialogVisible: false,
            /**放盘方式权限 */
            isUseStandard: true,
            isUseSuper: true,
            isUseStar: true,
            isDisabledPublish:false,
            /**鑽石還是金幣 提示 */
            diamondOrCoin: '',
            /**是否能夠購買金幣 */
            isBuyDiamond: true,
            isBuyCoin: true,
            isUsedDiamondPrompt: false,
            isShowDiamondPrompt: false,
            /**是否开启金币*/
            isUsedCoin: true,
            /**是否开启砖石 */
            isUsedDiamond: true,
            /**是否显示金币订单相关 */
            isShowCoinHistory: true,
            /**是否显示钻石订单相关 */
            isShowDiamondHistory: true,
            paymentTypeList: [],
            detailOrder: {},
            isPay: false,
            isDel: false,
            firstLoading: true,
            isDepartment: false,
            /**訂單類型列表 */
            sourceTypeList: [],
            /**圖文 列表展示控制 */
            pageIndex: 1,
            pageCount: 10,
            count: 0,
            orderList: [],
            topType: '',
            upgradeType:'',
            sourceType: null, //訂單類型
            orderStatusList: [], //訂單狀態列表
            orderStatus: '', //訂單狀態
            orderPaymentType: [],
            paymentType: '',
            orderId: '', //訂單id
            checkIntNum: '',
            startTime: '', //起止時間
            endTime: '', //截止時間
            departmentID: '', //組別id
            departmentList: [], //组织列表
            userInfo: [],
            startTimeOption: {
                disabledDate: this.startTimeOption1
            },
            endTimeOption: {
                disabledDate: this.endTimeOption1
            },
            sourceID: '',
            couponNo:''
        };
    },
    async created() {
        /**組別 */
        if (this.$route.params.departmentid) {this.departmentID = this.$route.params.departmentid;}
        /**訂單状态 */
        if (this.$route.params.orderstatus === 0 || this.$route.params.orderstatus === 1 || this.$route.params.orderstatus === 2) {
            this.orderStatus = String(this.$route.params.orderstatus);
        }
        /**订单类型 */
        if (this.$route.params.ordersourcetype) {
            this.sourceType = this.$route.params.ordersourcetype;
        }
        /**获取登录用户信息 */
        await this.axios.get(this.pub.getApi().GetCompanyUserInfo).then(res => {
            if (res.data.code === 0 && res.data.result) {
                this.userInfo = res.data.result;
                //获取组织
                this.loadTreeDepartments();
                this.loadGetPermission();
            }
        });
        this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'orderPageCount') || 10;
        /**首次获取列表数据 */
        this.loadOrderList(true);
        /**獲取字典信息 */
        let rescom = await this.axios.get(this.pub.getApi().GetCompanyCofig);
        if (rescom.data.code === 0 && rescom.data.result) {
            this.isShowDiamondHistory = rescom.data.result.isShowDiamondHistory;
            this.isShowCoinHistory = rescom.data.result.isShowCoinHistory;
            this.isUsedDiamond = rescom.data.result.isUsedDiamond;
            this.isUsedCoin = rescom.data.result.isUsedCoin;
            this.isBuyDiamond = rescom.data.result.isBuyDiamond;
            this.isBuyCoin = rescom.data.result.isBuyCoin;
            this.isUseStandard = rescom.data.result.isUseStandard;
            this.isUseSuper = rescom.data.result.isUseSuper;
            this.isUseStar = rescom.data.result.isUseStar;
            this.isDisabledPublish = rescom.data.result.isDisabledPublish
        }
        this.pub.getDictionary().then(res => {
            /**訂單狀態列表 */
            this.orderStatusList = res.OrderStatus.children;
            this.sourceTypeList = res.OrderSourceType.children;
            this.orderPaymentType = res.OrderPaymentType.children;
            /** 判断是否开启 金币或者钻石记录 */
            this.showCoinOrDiamondHistory();
        });
    },
    methods: {
        getOrderTime(val) {
            let day = new Date(val * 1000);
            let y = day.getFullYear();
            let m = day.getMonth() + 1;
            let d = day.getDate();
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
        },
        async downloadExl() {
            this.orderDatas = [];
            // 如果选择自订日期且没有填写日期
            if (this.checkedCities == '自訂日期' && this.value1.length == 0) {
                this.warnShow = true;
                this.dialogVisible = true;
                return;
            } else if (this.checkedCities == '全部' || (this.checkedCities == '自訂日期' && this.value1.length !== 0)) {
                this.warnShow = false;
                this.dialogVisible = false;
            }
            const loading = this.$loading({
                lock: true,
                text: '正在努力導出數據,大約會耗時幾分鐘，請不要關閉當前網頁',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // * 弹出弹框
            this.dialogVisible = false;
            // 筛选项+弹框共同筛选导出订单
            const searchData = this.getSearchValue();
            const data = {
                ...searchData,
                exportStartTime: this.value1 ? this.value1[0] / 1000 : '',
                exportEndTime: this.value1 ? this.value1[1] / 1000 + 86400 : ''
            };
            await this.axios.post(this.pub.getApi().SearchAllOrderRecord, data).then(res => {
                if (res.data.code == 0) {
                    this.orderDatas = res.data.result;
                } else {
                    loading.close();
                    this.$message({
                        message: `未有訂單記錄可導出`,
                        type: 'error',
                        showClose: true
                    });
                }
            });
            if (!this.orderDatas || this.orderDatas.length == 0) {
                loading.close();
                return;
            } 

              const arr = [];
              this.orderDatas.forEach(item => {
                    let obj = {};
                    obj.訂單編號 = item.orderID;
                    obj.賬戶類型 = item.accountType ? '公司賬戶' : '個人賬戶';
                    obj.組別 = item.departmentName;
                    obj.訂單類型 = item.itemWithCulture;
                    obj.樓盤編號 = item.sourceID;
                    obj.訂單狀態 = item.orderStatusWithCulture;
                    obj.時間 = this.getOrderTime(item.createTime);
                    if (this.isShowCoinHistory && this.isShowDiamondHistory) {
                        obj.金幣數量 = item.propertyCoin;
                        obj.鑽石數量 = item.diamond;
                    } else if (this.isShowCoinHistory) {
                        obj.金幣數量 = item.propertyCoin;
                    } else {
                        obj.鑽石數量 = item.diamond;
                    }

                    obj.操作人 = item.accountName;
                    arr.push(obj);
                });
            let header = {};
            if (this.isShowCoinHistory && this.isShowDiamondHistory) {
                header = { header: ['訂單編號', '賬戶類型', '訂單類型', '樓盤編號', '訂單狀態', '時間', '金幣數量', '鑽石數量', '操作人'] };
            } else if (this.isShowCoinHistory) {
                header = { header: ['訂單編號', '賬戶類型', '訂單類型', '樓盤編號', '訂單狀態', '時間', '金幣數量',  '操作人'] };
            } else {
                header = { header: ['訂單編號', '賬戶類型', '訂單類型', '樓盤編號', '訂單狀態', '時間', '鑽石數量', '操作人'] };
            }
            const ws = XLSX.utils.json_to_sheet(arr, header);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, `${this.userInfo.departmentName}訂單記錄`);
                XLSX.writeFile(wb, `${this.userInfo.departmentName}訂單記錄.xlsx`);
                loading.close();
        },
        dateChange() {
            if (this.checkedCities !== '自訂日期') {
                this.value1 = [];
            }
        },
        depExc() {
            this.checkedCities = '';
            this.dialogVisible = true;
            this.value1 = [];
            this.checkedCities = '全部';
            this.warnShow = false;
        },
        normalizeOptions(options, parentKey = '') {
            return options.map(opt => {
                const newKey = parentKey ? `${parentKey}_${opt.dictionaryValue}` : opt.dictionaryValue;
                return {
                    ...opt,
                    dictionaryValue: newKey, // 保证唯一
                    children: opt.children ? this.normalizeOptions(opt.children, newKey) : null
                };
            });
        },
        /** 判断是否开启 金币或者钻石记录 */
        showCoinOrDiamondHistory() {
            /** isShowDiamondHistory 是否看到钻石记录  */
            if (!this.isShowDiamondHistory) {
                if (this.sourceTypeList && this.sourceTypeList.length) {
                    this.sourceTypeList.forEach((item, index) => {
                        if (item.dictionaryValue == 'Diamond') {this.sourceTypeList.splice(index, 1);}
                    });
                }
                if (this.orderPaymentType && this.orderPaymentType.length) {
                    this.orderPaymentType.forEach((item, index) => {
                        if (item.dictionaryValue == 3) {this.orderPaymentType.splice(index, 1);}
                    });
                }
            }
            // isShowCoinHistory 是否看到金币记录
            if (!this.isShowCoinHistory) {
                if (this.sourceTypeList && this.sourceTypeList.length) {
                    this.sourceTypeList.forEach((item, index) => {
                        if (item.dictionaryValue == 'PropertyCoin') {this.sourceTypeList.splice(index, 1);}
                    });
                }
                if (this.orderPaymentType && this.orderPaymentType.length) {
                    this.orderPaymentType.forEach((item, index) => {
                        if (item.dictionaryValue === '0') {this.orderPaymentType.splice(index, 1);}
                    });
                }
            }
            // 刊登楼盘筛选项是否展示对应为该选项是否开启了使用
            const excludeValues = [];
            if (!this.isUseStandard) {excludeValues.push('0');}
            if (!this.isUseSuper) {excludeValues.push('1');}
            if (!this.isUseStar) {excludeValues.push('3');}
            if (excludeValues && excludeValues.length){
                this.sourceTypeList.forEach(item => {
                    if (item.dictionaryValue === 'Property' && item.children) {
                        item.children = item.children.filter(child => 
                            !excludeValues.includes(child.dictionaryValue)
                        );
                    }
                });
            }

            if (this.sourceTypeList && this.sourceTypeList.length && this.isDisabledPublish) {
                    this.sourceTypeList.forEach((item, index) => {
                        if (item.dictionaryValue == 'Coupon') {this.sourceTypeList.splice(index, 1);}
                });
            }
            if (this.orderPaymentType && this.orderPaymentType.length && this.isDisabledPublish) {
                    this.orderPaymentType.forEach((item, index) => {
                        if (item.dictionaryValue == 7) {this.orderPaymentType.splice(index, 1);}
                });
            }
            if(this.userInfo.roleID == 3){
                this.sourceTypeList = this.sourceTypeList.filter(item =>item.dictionaryValue !== 'Diamond' && item.dictionaryValue !== 'PropertyCoin')               
            }
            this.sourceTypeList = this.normalizeOptions(this.sourceTypeList)
        },
        /* 选择项目改变 */
        handleSelectionChange(val) {
            this.isDel = false;
            this.isPay = false;
            this.detailOrder = {};
            if (val.length !== 1) {return;}
            this.detailOrder = val[0];
            if (val[0].orderStatus === 0 && val[0].accountID === this.userInfo.accountID && val[0].departmentID === this.userInfo.departmentID) {
                this.isPay = true;
                this.isDel = true;
            }
        },
        /**新开窗口进入详情页 */
        enterDetails(type, id) {
            /**楼盘被删除 无法查看详情 */
            if (!type) {
                this.$message({
                    showClose: true,
                    message: '該樓盤已被刪除，暫時無法查看詳情',
                    type: 'warning'
                });
                return;
            }
            let url = `${this.pub.config.pcUrl}${type === 1 ? 'buy' : 'rent'}-property-${id}.html`;
            window.open(url);
        },
        /**判断权限 */
        loadGetPermission() {
            this.axios
                .post(this.pub.getApi().GetPermissionByRoleId, {
                    roleID: this.userInfo.roleID
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        res.data.result.forEach(item => {
                            if (
                                /**是否是超级管理员 */
                                item.permissionsCode === 'Property_PropertyManage_Manager_All'
                            ) {
                                this.isDepartment = true;
                            } else if (item.permissionsCode === 'Property_PropertyManage_ExamineList_All') {
                                this.isDepartment = true;
                            }
                        });
                    }
                });
        },
        /**时间选择 */
        startTimeOption1(time) {
            if (this.endTime) {
                return time.getTime() > this.endTime;
            } 
                return false;
            
        },
        endTimeOption1(time) {
            if (this.startTime) {
                return time.getTime() < this.startTime;
            } 
                return false;
            
        },
        checkInt(data) {
            /** 价格只能为数字 切最多为六位 */
            if (/^$|^\d{0,20}$/.test(this[data])) {
                // 校验通过，记录当前合法值
                this.checkIntNum = this[data];
            } else {
                // 校验失败，回退到上一次的合法值
                this[data] = this.checkIntNum;
            }
        },
        // checkInt(data) {
        //     /** 价格只能为数字 切最多为六位 */
        //     /^$|^\d{0,20}$/.test(this[data]) ? (this.checkIntNum = this[data]) : (this[data] = this.checkIntNum);
        // },
        /**改变每页数据 */
        sizeChange(data) {
            this.pub.userPageSize(this.userInfo.accountID,'orderPageCount',data) 
            this.pageCount = data;
            this.loadOrderList();
        },
        /**获取组织 */
        loadTreeDepartments() {
            this.axios
                .get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                    params: { departmentID: this.userInfo.departmentID }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.departmentList.push(res.data.result);
                    }
                });
        },
        /**點擊搜索 */
        clickSearch() {
            this.pageIndex = 1;
            this.loadOrderList();
        },
        /**重置 */
        resetSearch() {
            this.paymentTypeList = [];
            this.topTypeList = [];
            this.topType = '';
            this.upgradeType = '';
            this.sourceType = null;
            this.orderStatus = '';
            this.orderId = '';
            this.startTime = '';
            this.endTime = '';
            this.departmentID = '';
            this.sourceID = '';
            this.couponNo = ''
            this.paymentType = '';
            this.clickSearch();
        },
        /**獲取訂單記錄 */
        loadOrderList(first) {
            // const data = this.getSearchValue();
           let data ={}
           if(this.isDisabledPublish && first){
               data ={"pageIndex":1,"pageCount":20,"sourceTypeList":["property","propertyCoin"],"paymentTypeList":["payPal","bankTransfer","payDollar","payDollarAliPayHKOnl","payDollarWechatOnl","propertyCoin"]}
            }else{
                data = this.getSearchValue();
            }
            this.axios.post(this.pub.getApi().SearchOrderRecord, data).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.orderList = res.data.result.data;
                    // console.log("this.orderList",this.orderList)
                    this.count = res.data.result.count;
                    if (first) {this.firstLoading = false;}
                }
            });
        },
        /**轉換搜索數據 */
        getSearchValue() {
            const data = {};
            data.pageIndex = this.pageIndex;
            data.pageCount = this.pageCount;
            //缺少组织 013空或者不存在
            if (this.departmentID) {data.departmentID = this.departmentID;}
            if (this.sourceType === 1) {data.sourceType = 'PropertyCoin';}
            else if (this.sourceType === 2) {data.sourceType = 'Property';}
            else if (this.sourceType === 3) {data.sourceType = 'Diamond';}
            else if (this.sourceType) {data.sourceType = this.sourceType;}
            /**刊登楼盘细分 星级 精选 标准 */
            if (this.sourceType === 'Property_0') {
                data.sourceType = 'Property';
                data.topType = 'normal';
            } else if (this.sourceType === 'Property_1') {
                data.sourceType = 'Property';
                data.topType = 'goldTop';
            } else if (this.sourceType === 'Property_3') {
                data.sourceType = 'Property';
                data.topType = 'star';
            }else if(this.sourceType === 'Property_'){
                data.sourceType = 'Property';
                data.topType = '';
            }

            /**升级楼盘细分 星级 精选 标准 */
            if (this.sourceType === 'PropertyUpgradeType_3') {
                data.sourceType = 'PropertyUpgradeType';
                data.upgradeType = 3;
            } else if (this.sourceType === 'PropertyUpgradeType_1') {
                data.sourceType = 'PropertyUpgradeType';
                data.upgradeType = 1;
            } else if (this.sourceType === 'PropertyUpgradeType_2') {
                data.sourceType = 'PropertyUpgradeType';
                data.upgradeType = 2;
            }else if(this.sourceType === 'PropertyUpgradeType_'){
                data.sourceType = 'PropertyUpgradeType';
                data.upgradeType = '';
            }

            if(this.sourceType === null){
                data.sourceType = '';
                data.topType = '';
                data.upgradeType = '';
            }

            if (this.paymentType) {data.paymentType = this.paymentType;}
            if (this.paymentTypeList && this.paymentTypeList.length) {
                data.paymentTypeList = this.paymentTypeList;
                this.paymentTypeList.forEach(item => {
                    if (item === 0) {data.paymentTypeList = [];}
                });
            }
            if (this.orderStatus) {data.orderStatus = this.orderStatus;}
            if (this.orderId) {data.orderId = [this.orderId];}
            if (this.startTime) {data.startTime = this.startTime / 1000;}
            if (this.endTime) {data.endTime = this.endTime / 1000 + 24 * 60 * 60;}
            if (this.sourceID) {
                // data.sourceType = 'Property';
                data.sourceID = this.sourceID;
            }
            if (this.couponNo) {data.couponNo = this.couponNo}
            return data;
        },
        /**立即支付 */
        async clickPay() {
            if (!this.isPay) {return;}
            if(this.detailOrder.sourceType === 'Property'){
                await this.axios
                   .post(this.pub.getApi().RequiredProperty, {
                       propertyId: this.detailOrder.sourceID
                   })
                   .then(res => {
                       // 付款的楼盘缺少必填
                       if (!res.data.result) {
                           this.isShowPayPrompt = true;
                       }
                   });
                   if( this.isShowPayPrompt){return} 
            }
            /**判断是否开启放盘方式 */
            if (!this.isUseStandard && this.detailOrder.topTypeStr == '標準盤') {
                this.isShowDiamondPrompt = true;
                return;
            }
            if (!this.isUseSuper && this.detailOrder.topTypeStr == '精選盤') {
                this.isShowDiamondPrompt = true;
                return;
            }
            if (!this.isUseStar && this.detailOrder.topTypeStr == '星級盤') {
                this.isShowDiamondPrompt = true;
                return;
            }
            // /**未开启使用钻石 */
            // if (!this.isUsedDiamond && (this.detailOrder.topTypeStr == '精選盤' || this.detailOrder.topTypeStr == '星級盤')) {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            // /**未开启使用金币 */
            // if (!this.isUsedCoin && this.detailOrder.topTypeStr == '標準盤') {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            if (this.detailOrder.sourceType === 'Property') {
                /**放盤付款 後期需調整*/
                this.$router.push({
                    path: '/property/post',
                    query: {
                        type: '1',
                        propertyId: this.detailOrder.sourceID,
                        backUrl: '/order/index'
                    }
                });
            } else if (this.detailOrder.sourceType === 'PropertyCoin' || this.detailOrder.sourceType === 'Diamond') {
                // isBuyCoin isBuyDiamond
                if (this.detailOrder.sourceType === 'Diamond' && !this.isBuyDiamond) {
                    this.diamondOrCoin = 'Diamond';
                    this.isUsedDiamondPrompt = true;
                    return;
                }
                if (this.detailOrder.sourceType === 'PropertyCoin' && !this.isBuyCoin) {
                    this.diamondOrCoin = 'Coin';
                    this.isUsedDiamondPrompt = true;
                    return;
                }
                localStorage.setItem('saveExptime', this.detailOrder.expireTimeCulture);
                // 跳转 订单详情
                this.$router.push({
                    path: '/coin/order-detail',
                    query: {
                        orderId: this.detailOrder.orderID
                    }
                });
                /**贖買金幣 钻石*/
                // this.$router.push({
                //     path: '/coin/order-pay',
                //     query: {
                //         orderId: this.detailOrder.orderID,
                //         backUrl: '/order/index',
                //         expireTime: this.detailOrder.expireTimeCulture
                //     }
                // });
            }
        },
        /**取消訂單 */
        cancelOrder() {
            if (!this.isDel) {return;}
            this.$confirm('是否確認要取消該訂單', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.axios
                        .get(this.pub.getApi().CloseOrderAsync, {
                            params: {
                                orderId: this.detailOrder.orderID
                            }
                        })
                        .then(res => {
                            if (res.data.code === 0 && res.data.result) {
                                this.loadOrderList();
                                this.$message({
                                    showClose: true,
                                    message: '取消成功',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: '取消失败，请重试',
                                    type: 'warning'
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        type: 'warning',
                        message: '已取消操作'
                    });
                });
        },
        /**分頁 切換頁面 */
        currentChange(pageIndex) {
            this.pageIndex = pageIndex;
            this.loadOrderList();
        },
        /**分頁處理 */
        pageCountChange() {
            const _this = this;
            clearTimeout(this.timeId);
            this.timeId = setTimeout(function () {
                _this.loadOrderList();
            }, 1000);
        }
    }
};
</script>

<style lang="less">
.el-button--danger {
    background: #e50113;
}
.el-button--info {
    background: #bbbbbb;
    border: 1px solid #bbb;
}
.order {
    .ti-me {
        .dateAll {
            margin-bottom: 20px;
            .dateSel {
                position: absolute;
            }
        }
        .selDat {
            color: red;
            margin-left: 80px;
        }
        .el-dialog {
            border-radius: 8px;
            .el-button {
                border-radius: 10px;
            }
        }
        .el-dialog__header {
            padding: 9px 32px;
            background: rgb(250 250 251);
            border-bottom: 1px solid rgb(226 226 234);
            border-radius: 8px 8px 0 0;
            .el-dialog__title {
                font-size: 16px;
                color: rgb(102 102 102);
            }
        }
        i.el-icon-close {
            position: absolute;
            top: -7px;
            left: -8px;
        }
    }

    /**提示框 */
    .ti-shi {
        .el-dialog__body {
            padding: 20px 30px 25px;
        }
        .tishi {
            position: relative;
            padding-left: 70px;
            line-height: 24px;
            color: #44444f;
            font-size: 14px;

            .icon {
                left: 32px;
                top: 6px;
                position: absolute;
                color: #0064ff;
                font-size: 18px;
            }
        }
        .del-tishi {
            div {
                color: #44444f;
                font-size: 15px;
                span.span {
                    display: inline-block;
                    padding-left: 12px;
                    margin-bottom: 8px;
                }
                .num {
                    padding-left: 30px;
                    line-height: 28px;
                }
            }
            p {
                margin-top: 8px;
                font-size: 14px;
                color: #f04134;
                padding-left: 30px;
            }
            .icon {
                color: #faad14;
                font-size: 18px;
            }
        }
    }
    /* 按钮样式 */
    .el-button {
        height: 38px;
        width: 95px;
    }
    background-color: #f3f3f5;
    margin: 0 auto;
    text-align: left;
    .title {
        padding: 0 0 20px 0;
        font-size: 24px;
        color: #171725;
        .span {
            padding-left: 20px;
            font-size: 12px;
            color: #0062ff;
        }
    }
    .button {
        overflow: hidden;
        padding: 25px 0 0px 5px;
        .span {
            height: 32px;
            cursor: pointer;
            display: inline-block;
            padding: 0 14px;
            .icon {
                font-size: 20px;
            }
            .btn-text {
                position: relative;
                top: 0px;
                font-size: 15px;
                padding-left: 6px;
                color: #0062ff;
            }
            .ban {
                color: #666;
            }
        }
    }
    .filter {
        padding-bottom: 16px;
        input {
            border-radius: 10px;
            height: 38px;
            border: none;
        }
        button {
            border-radius: 10px;
            width: 88px;
            height: 38px;
        }
        .w165,
        .w160,
        .w150,
        .w120 {
            margin-right: 18px;
            margin-bottom: 12px;
        }
        .w165 {
            width: 165px;
        }
        .w160 {
            width: 160px;
        }
        .w150 {
            width: 150px;
        }
        .w120 {
            width: 120px;
        }
        .mr4 {
            margin-right: 4px;
        }
        .hoverButton {
            width: 88px;
            margin-left: 10px;
            margin-top: 10px;
            border-radius: 10px;
            height: 38px;
            background-color: rgb(187 187 187);
            border-color: transparent;
            color: rgb(255 255 255);
            cursor: pointer;
        }
        .hoverButton:hover {
            color: rgb(255 255 255);
            background-color: rgb(0 100 255);
        }
        span.time {
            font-size: 14px;
            color: #666;
        }
    }
    .line {
        width: 100%;
        height: 1px;
        background-color: #e2e2ea;
    }

    .table {
        // .order-statu {
        //     padding-left: 14px;
        // }

        .order-statu-red {
            color: #e50113;
        }
        .el-button {
            text-align: left;
            width: 100%;
        }
        .btn-a {
            color: #0062ff;
        }
        margin-top: 20px;
        table,
        tr,
        td,
        th {
            border: none;
        }
        .el-table tbody tr:hover > td {
            background-color: rgba(80, 181, 255, 0.1) !important;
        }

        /deep/ .el-table thead tr {
            th:first-child {
                border-radius: 10px 0 0 10px;
            }
            th:nth-last-child(2) {
                border-radius: 0 10px 10px 0;
            }
        }
        /**勾选框颜色覆盖 */
        .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #0064ff;
            border-color: #0064ff;
        }
        .el-table__header tr,
        .el-table__header th {
            padding: 0;
            height: 38px;
        }
        .el-table th {
            border: none;
        }
        .el-table td {
            border-bottom: 1px solid #e2e2ea;
        }
        table {
            color: #222;
            font-size: 14px;
            tr th .cell {
                font-weight: normal;
                font-size: 12px;
                color: #44444f;
            }
        }
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;
        .img-list {
            .r-btn {
                padding-right: 12px;
                margin-top: 16px;
                width: 100%;
                border-top: 1px solid #eee;
                padding-top: 6px;
                box-sizing: border-box;
                .el-button {
                    padding-left: 12px;
                    float: right;
                }
            }
            td {
                position: relative;
            }
            .cell .img {
                text-align: center;
            }
            .cell img {
                position: absolute;
                left: 8px;
                top: 18px;
            }
            .title {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-weight: 700;
                font-size: 17px;
                line-height: 24px;
                color: #333333;
                padding: 0;
            }
            .detail {
                .fl {
                    flex: 1;
                    color: #999;
                }
                .fr {
                    color: #666;
                    text-align: right;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .adress {
                    padding-left: 20px;
                    color: #666;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .red {
                    color: #ed1d25;
                }
                font-size: 12px;
                color: #999999;
                line-height: 23px;
                .el-col.el-col-5 {
                    margin-right: 100px;
                    width: 150px;
                    display: flex;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .line-detail {
                margin-top: 12px;
                width: 100%;
                height: 1px;
                background-color: #e2e2ea;
            }
            .img img {
                width: 120px;
                height: 90px;
                background-size: 100% 100%;
            }
        }
        .footer {
            span {
                font-size: 14px;
                color: #44444f;

                margin-left: 16px;
            }
            margin-top: 16px;
            // border-top: 1px solid #e2e2ea;
            padding-top: 20px;
            box-sizing: border-box;
            height: 72px;
            .page {
                float: right;
            }
            .input-number {
                text-align: left;
                float: right;
                width: 70px;
            }
            /**覆盖计数器样式 */
            .el-input-number.is-controls-right .el-input__inner {
                padding-left: 8px;
                padding-right: 42px;
            }
        }
    }
}
</style>
